import dayjs, { Dayjs } from "dayjs"

export const getTimeZoneFullText = (timeZone: string) => {
  if (!timeZone) return null

  if (timeZone === "UTC") return "UTC"

  return `${timeZone.replace("_", " ")} UTC ${dayjs()
    .tz(timeZone || "UTC")
    .format("Z")}`
}

export const stringifyDateRange = (dateRange: [Dayjs | null | string, Dayjs | null | string], showLongText = false) => {
  const start = typeof dateRange[0] === "string" ? dateRange[0] : dateRange[0]?.format("YYYY-MM-DD")
  const end = typeof dateRange[1] === "string" ? dateRange[1] : dateRange[1]?.format("YYYY-MM-DD")

  if (start && end && start === end) {
    return start
  }

  if (showLongText && start && end) {
    return `from ${start} to ${end}`
  }

  if (start && end) {
    return `${start} - ${end}`
  }

  if (start) {
    return `from ${start}`
  }

  if (end) {
    return `until ${end}`
  }

  return ""
}
